import Vue from 'vue'

export default new Vue({
  data () {
    return {
      lastUpdated: null,
      isSidebarExpanded: false,
      notifications: [],
      width: 0,
    }
  }
})
